import React, { createContext, useContext, useMemo } from "react";
import { Text as RNText } from "react-native";

import { normalizeExhibitLanguage, translateExhibitDisplayText } from "./exhibitLocale";

const ExhibitLocaleContext = createContext({ language: "en" });

export function ExhibitLocaleProvider({ language = "en", children }) {
  const value = useMemo(
    () => ({ language: normalizeExhibitLanguage(language) }),
    [language]
  );
  return (
    <ExhibitLocaleContext.Provider value={value}>
      {children}
    </ExhibitLocaleContext.Provider>
  );
}

export function useExhibitLanguage() {
  return useContext(ExhibitLocaleContext)?.language || "en";
}

function localizeChild(language, child) {
  if (typeof child === "string") return translateExhibitDisplayText(language, child);
  if (Array.isArray(child)) return child.map((item) => localizeChild(language, item));
  return child;
}

export const LocalizedText = React.forwardRef(function LocalizedText(
  { children, accessibilityLabel, ...props },
  ref
) {
  const language = useExhibitLanguage();
  return (
    <RNText
      {...props}
      ref={ref}
      accessibilityLabel={
        typeof accessibilityLabel === "string"
          ? translateExhibitDisplayText(language, accessibilityLabel)
          : accessibilityLabel
      }
    >
      {React.Children.map(children, (child) => localizeChild(language, child))}
    </RNText>
  );
});
